import { render, staticRenderFns } from "./homeR.vue?vue&type=template&id=2893d21a&scoped=true"
import script from "./homeR.vue?vue&type=script&lang=js"
export * from "./homeR.vue?vue&type=script&lang=js"
import style0 from "./homeR.vue?vue&type=style&index=0&id=2893d21a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2893d21a",
  null
  
)

export default component.exports